import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

const UserAuthContext = createContext();

export const UserAuthProvider = ({ children }) => {
    const [user, loading, error] = useAuthState(auth);
    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        if (user) {
            getDoc(doc(db, `users/${user.uid}`)).then((querySnapshot) => {
                setUserInfo(querySnapshot.data())
            });
        }
    }, [user]);

    return (
        <UserAuthContext.Provider value={{ user, userInfo, loading, error }}>
            {children}
        </UserAuthContext.Provider>
    );
};

export const useAuthUser = () => useContext(UserAuthContext);